// @TODO Make this a component, and type it props

export * as PreferenceList from './styled';
